"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.orgProfileSchema = void 0;
const joi_1 = __importDefault(require("joi"));
const AddressValidator_1 = require("../../shared/validators/AddressValidator");
const ContactInfoValidator_1 = require("../../shared/validators/ContactInfoValidator");
const FaqValidator_1 = require("../../shared/validators/FaqValidator");
const GenericValidator_1 = __importDefault(require("../../shared/validators/GenericValidator"));
const EditStatus_1 = require("../models/OrgProfile/EditStatus");
const IndustryExpertise_1 = require("../models/OrgProfile/IndustryExpertise");
const ProfileStatus_1 = require("../models/OrgProfile/ProfileStatus");
const WarehouseCapabilities_1 = require("../models/OrgProfile/WarehouseCapabilities");
const WarehouseInfoValidator_1 = require("./WarehouseInfoValidator");
const _orgProfileStatus = Object.values(ProfileStatus_1.ProfileStatus);
const _editStatus = Object.values(EditStatus_1.EditStatus);
const _industryExpertise = Object.values(IndustryExpertise_1.IndustryExpertise);
const _warehouseCapabilities = Object.values(WarehouseCapabilities_1.WarehouseCapabilities);
exports.orgProfileSchema = joi_1.default.object({
    id: joi_1.default.string().allow('').required(),
    orgKey: joi_1.default.string().required(),
    status: joi_1.default.string().valid(..._orgProfileStatus),
    editStatus: joi_1.default.string()
        .valid(..._editStatus)
        .default(EditStatus_1.EditStatus.draft),
    name: joi_1.default.string()
        .max(200)
        .min(1)
        .trim()
        .pattern(/^[\w\d][\s\S]*/)
        .required(),
    website: joi_1.default.string().required(),
    foundedIn: joi_1.default.number()
        .integer()
        .min(1900)
        .max(new Date().getFullYear())
        .required(),
    joinedExtensivIn: joi_1.default.number()
        .integer()
        .min(1900)
        .max(new Date().getFullYear()),
    logo: joi_1.default.string().required(),
    contact: ContactInfoValidator_1.contactInfoSchema,
    address: AddressValidator_1.addressSchema,
    companySummary: joi_1.default.string().allow(''),
    description: joi_1.default.string(),
    faqs: joi_1.default.array()
        .items(FaqValidator_1.faqSchema)
        .unique((a, b) => a.index === b.index),
    warehouseInfo: joi_1.default.array().items(WarehouseInfoValidator_1.warehouseInfoSchema),
    salesforceContactId: joi_1.default.string(),
    salesforceAccountId: joi_1.default.string(),
    hubspotRowId: joi_1.default.string(),
    expertise: joi_1.default.array().items(joi_1.default.string().valid(..._industryExpertise)),
    sortOrder: joi_1.default.number().integer(),
    preferredRegion: joi_1.default.string(),
    featured: joi_1.default.boolean(),
    defaultRecommendation: joi_1.default.boolean(),
    pagePath: joi_1.default.string(),
    capabilities: joi_1.default.array().items(joi_1.default.string().valid(..._warehouseCapabilities)),
    lastUpdatedDate: joi_1.default.number().integer(),
});
class OrgProfileValidator extends GenericValidator_1.default {
    constructor() {
        super({ convert: true });
    }
    validate(input) {
        super.validate(input, 'IOrgProfile', exports.orgProfileSchema);
    }
}
exports.default = OrgProfileValidator;
